/**
 * Centralized audio utility functions
 */

/**
 * Play error sound for invalid barcode/design number scans
 * Uses audio file with Web Audio API fallback
 */
export function playErrorSound () {
  try {
    const audio = new Audio('/sounds/error-beep.mp3')
    audio.volume = 0.5
    audio.play().catch(() => {
      // Fallback: use Web Audio API for a simple beep
      const audioContext = new (window.AudioContext || window.webkitAudioContext)()
      const oscillator = audioContext.createOscillator()
      const gainNode = audioContext.createGain()
      oscillator.connect(gainNode)
      gainNode.connect(audioContext.destination)
      oscillator.frequency.value = 400
      oscillator.type = 'square'
      gainNode.gain.value = 0.3
      oscillator.start()
      setTimeout(() => {
        oscillator.stop()
        audioContext.close()
      }, 200)
    })
  } catch (e) {
    console.warn('Could not play error sound:', e)
  }
}
